import actions from '@/core/store/adesao/revisoes/actions'

export default {
	actions,
}
